import React from 'react';

const AppInfoCard = () => {
  const date = new Date();
  const year = date.getFullYear().toString() || '2020';

  return (
    <div className="mb-10 card">
      <div className="cardBody">
        <aside>
          <h2 className="font-semibold">App Info</h2>
        </aside>
        <main className="text-sm text-gray-500">
          Cash Board ©{year} JCAP Treasury Services Ltd.
          <br />
          {process.env.REACT_APP_BRANCH || 'UNDEFINED'} BUILD
          <br />
          {process.env.REACT_APP_VERSION && (
            <>Release {process.env.REACT_APP_VERSION}</>
          )}
          <br />
          ENDPOINT: {process.env.REACT_APP_HASURA_ENDPOINT || 'UNDEFINED'}
        </main>
      </div>
    </div>
  );
};

export default AppInfoCard;
